class ModalNewsletter extends window.BAO.CustomElement({
  SuperClass: HTMLDialogElement,
}) {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.onTrigger = this.onTrigger.bind(this)
    this.onClose = this.onClose.bind(this)
    this.onSwitchView = this.onSwitchView.bind(this)
    this.onFormSubmit = this.onFormSubmit.bind(this)

    this.listeners.add(
      this.externalEls?.trigger?.element,
      'click',
      this.onTrigger,
    )

    this.els?.close?.elements.forEach((closeEl) => {
      this.listeners.add(closeEl, 'click', this.onClose)
    })

    this.listeners.add(this.els['form-trigger']?.element, 'click', () =>
      this.onSwitchView(true),
    )

    this.listeners.add(this.els?.form?.element, 'submit', this.onFormSubmit)
  }

  onTrigger () {
    this.els?.text.element.setAttribute('aria-hidden', false)
    this.showModal()
  }

  onClose () {
    this.close()
    this.onSwitchView(false)
  }

  onSwitchView (showForm) {
    this.els?.content?.element.setAttribute('aria-hidden', showForm)
    this.els['form-container']?.element.setAttribute('aria-hidden', !showForm)
  }

  onFormSubmit (event) {
    this.els?.text.element.setAttribute('aria-hidden', true)
  }
}

if (!customElements.get('modal-newsletter')) {
  customElements.define('modal-newsletter', ModalNewsletter, {
    extends: 'dialog',
  })
}
